import { Suspense } from 'react'
import { I18nextProvider } from 'react-i18next'
import { Provider as ReduxProvider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { APIProvider as MapProvider } from '@vis.gl/react-google-maps'
import { ThemeProvider } from '@mui/material/styles'
import muiThemes from './styles/muiTheme'
import i18n from './i18n'
import { store } from './redux/store'
import { router } from './router'
import { Loader } from './components/ui'
import { useFreshBuildWatcher } from './hooks/useFreshBuildWatcher'
import { useTheme } from './hooks/useTheme'

// Needs the i18n context, so it lives as a child of the providers.
const FreshBuildWatcher = () => {
  useFreshBuildWatcher()
  return null
}

function App() {
  const { theme } = useTheme()
  return (
    <div className="">
      <MapProvider libraries={['geometry']} apiKey={import.meta.env.VITE_MAPS_API_KEY}>
        <ReduxProvider store={store}>
          <ThemeProvider theme={muiThemes[theme]}>
            <I18nextProvider i18n={i18n}>
              <Suspense
                fallback={
                  <div className="flex items-center justify-center min-h-screen supports-[height:100dvh]:min-h-dvh">
                    <Loader />
                  </div>
                }
              >
                <RouterProvider router={router} />
              </Suspense>

              {/* Toasts follow the site's card styling instead of the default
                dark theme (client feedback) — see toast overrides in styles/index.css */}
              <FreshBuildWatcher />
              {/* 6s + a progress bar: readers can finish the message and see how
                long it stays; tap/X still dismisses it early (tester feedback) */}
              <ToastContainer
                autoClose={6000}
                theme="light"
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                limit={1}
              />
            </I18nextProvider>
          </ThemeProvider>
        </ReduxProvider>
      </MapProvider>
    </div>
  )
}

export default App
